/**
 * Helper pur (sans React/Tailwind compile) qui mappe un statut de document
 * a la classe CSS + l icone affichee dans la pill.
 *
 * Sortie volontairement decouplee du composant pour rester testable en
 * node:test sans bundler.
 *
 * S1.9 P1-B :
 *  - `manquant` -> rouge avec croix blanche (urgent, le client doit envoyer)
 *  - `na` (not applicable yet) -> gris pale sans icone (doc pas encore attendu,
 *    par exemple devis/AH tant que la collecte n est pas finie)
 */

/**
 * Renvoie la couleur+icone pour un statut donne.
 *
 * @param {string | undefined | null} status
 * @returns {{ cls: string, icon: string }}
 */
export function pillStyle(status) {
  switch (status) {
    case 'valide':
      return { cls: 'bg-emerald-500 text-white', icon: '✓' };
    case 'a_valider':
      return { cls: 'bg-orange-400 text-white', icon: '…' };
    case 'rejete':
      return { cls: 'bg-red-500 text-white', icon: '✗' };
    case 'manquant':
      // P1-B : manquant = rouge urgent (avant : gris, indistinguable de na)
      return { cls: 'bg-red-500 text-white', icon: '✗' };
    case 'na':
    default:
      // na = doc pas encore attendu (gris pale, sans icone)
      return { cls: 'bg-gray-200 text-gray-400', icon: '' };
  }
}
